<template>
    <v-sheet>
        <v-app-bar style="border-bottom:1px solid #ddd; " elevation="0" dense>
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="text-uppercase">
                <span>Gerenciador</span>
                <span class="font-weight-light">| Nova Música Gospel</span>
            </v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-spacer></v-spacer>
        </v-app-bar>

        <!-- Menu lateral -->

        <v-navigation-drawer
            v-model="drawer"
            fixed
            temporary
            left
            color="#fafafa"
            style="width: 350px; max-width:400px"
            class="mx-auto"
        >
            <v-list-item dense class="px-2">
                <v-list-item-avatar>
                    <v-img :src="'https://randomuser.me/api/portraits/men/'+userdata.id+'.jpg'"></v-img>
                </v-list-item-avatar>

                <v-list-item-title>{{ userdata.myself.name }} ({{ userdata.id }})</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>

            <v-list dense>
                <template v-for="item in menu_items">
                    <template v-if="item.items != undefined">
                        <v-list-group
                            :key="item.title"
                            v-model="item.active"
                            :prepend-icon="item.icon"
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title"></v-list-item-title>
                                </v-list-item-content>
                            </template>

                            <v-list-item
                                v-for="subItem in item.items"
                                :key="subItem.title"
                                :to="{ name: subItem.link, params: subItem.link_query }"
                            >
                                <v-list-item-icon>
                                    <v-icon>{{ subItem.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-group>
                    </template>
                    <template v-else>
                        <v-list-item
                            :to="{ name: item.link, params: item.link_query }"
                            :key="item.title"
                        >
                            <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </template>
            </v-list>

            <template v-slot:append>
                <v-list dense>
                    <div class="pa-2">
                        <v-btn block text
                            @click="$store.commit('token',null); $router.push({name:'login'})">                            
                            SAIR
                        </v-btn>
                    </div>
                </v-list>
            </template>
        </v-navigation-drawer>
    </v-sheet>
</template>
<script>
export default {
    props: {
        money_disabled: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        drawer: null,
        menu_items: [
            {
                title: "Dashboard",
                icon: "dashboard",
                link: "dashboard"
            },
            {
                title: "Lançamentos",
                icon: "open_in_browser",
                slug: "releases",
                items: [
                    {
                        title: "Próximos",
                        icon: "fast_forward",
                        link: "lancamentos_proximos"
                    },
                    {
                        title: "Calendário",
                        icon: "calendar_today",
                        link: "calendar"
                    }
                ]
            },
            {
                title: "Artistas",
                icon: "people",
                link: "artists",
                slug: "artists"
            },
            {
                title: "Produtos",
                icon: "music_video",
                slug: "products",
                items: [
                    {
                        icon: "album",
                        title: "Áudio",
                        link: "product_list_audio_filter_status",
                        link_query: { status: "underanalysis" }
                    },
                    {
                        icon: "video_library",
                        title: "Vídeo",
                        link: "product_list_video"
                    }
                ]
            },
            {
                title: "ISRCs",
                icon: "receipt",
                link: "isrcs",
                slug: "isrcs"
            },
            {
                title: "Financeiro",
                icon: "account_balance",
                slug: "financeiro",
                items: [
                    { icon: "shop", title: "Pedidos", link: "orders" },
                    {
                        icon: "monetization_on",
                        title: "Cotação",
                        link: "cotacaomensal"
                    },
                    {
                        icon: "payments",
                        title: "Liberação de Crédito",
                        link: "liberacaocredito_status",
                        link_query: { status: "cotacao_atualizada" }
                    },
                    {
                        icon: "account_balance_wallet",
                        title: "Liberação de Pagamento",
                        link: "liberacaopagamento_status",
                        link_query: { status: "not_payed" }
                    }
                ]
            }
        ]
    }),
    beforeCreate: function() {
       
    },
    created: function() {
         let userdata = this.$store.getters.user;
        console.log(userdata);
        if (userdata.financeiro==0) {        
            this.menu_items = this.menu_items.filter(function(e) {
                console.log(e);
                if (e.slug == "financeiro") {
                    return false;
                }
                return true;
            });
            
        }
    },
    computed: {
        userdata: function() {
            return this.$store.getters.user;
        }
    },
    methods: {
        ajuda_video() {
            this.$emit("open_wizard");
        }
    }
};
</script>
